export const EventName = Object.freeze({
	CloseWizard: 'booking:resource-creation-wizard:close',
	CloseYandexIntegrationWizard: 'booking:yandex-integration-wizard:close',
	CloseSkuResourcesEditor: 'booking:sku-resources-editor:close',
	CreateBookings: 'booking:booking:create',
	DeleteBooking: 'booking:booking:delete',
	UpdateBooking: 'booking:booking:update',
	StartLockedBookingAnimation: 'booking:booking:startLockedBookingAnimation',
});
